import React, { Fragment } from 'react';
import VideoListBrand from './video_list_brand';

const VideoList = ({ listData, title, titleText }) => {
  const brandItems = Object.entries(listData).map(([key, value], i) => (
    <VideoListBrand brand={key} brandVideos={value} key={i} />
  ));

  return (
    <Fragment>
      <h3 className="how-to-guides__title news__title">{title}</h3>
      <p className="how-to-guides__p">{titleText}</p>
      <div>{brandItems}</div>
    </Fragment>
  );
};

export default VideoList;
